import React, { FC } from 'react';
import { BrowserRouter, Switch, Route, RouteProps } from 'react-router-dom';

import Layout from 'components/layout/Layout';

import AppRoutes from './Routes';

export type AppRoute = Required<Pick<RouteProps, 'path' | 'component'>>;

const AppRouter: FC = () => (
	<BrowserRouter>
		<Layout>
			<Switch>
				{AppRoutes.map(route => (
					<Route
						exact
						key={`${route.path}`}
						path={route.path}
						component={route.component}
					/>
				))}
			</Switch>
		</Layout>
	</BrowserRouter>
);

export default AppRouter;
